import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_GET',
  GET_SUCCESS: 'TEACHER_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_GET_FAILURE',

  PATCH: 'TEACHER_PATCH',
  PATCH_SUCCESS: 'TEACHER_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_PATCH_FAILURE',

  INVALIDATE_ITEM: 'TEACHER_INVALIDATE_ITEM',
};

export const get = actions.get(
  (teacherId, query) => `${BASE_URL}/teachers/${teacherId}/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(teacherId => `${BASE_URL}/teachers/${teacherId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});

export const invalidateItem = (id, query) => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id, query },
  });
};
